import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

const Badge = styled.div`
  display: inline-block;
  padding: 6px 11px;
  padding-left: 19px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
  background: #f1e7ec;
  ${Text} {
    font-weight: 700;
    font-size: 11px;
    line-height: 15px;
    position: relative;
    color: #89375f;
    &:before {
      content: "";
      width: 4px;
      height: 4px;
      left: -8px;
      background: #89375f;
      top: calc(50% - 2px);
      border-radius: 50%;
      position: absolute;
    }
  }
`;

const ThirdPartyBadge: FC<{ className?: string }> = ({ className }) => {
  return (
    <Badge className={className}>
      <Text $type="smallHeadline">3rd party</Text>
    </Badge>
  );
};

export default ThirdPartyBadge;
